import { http } from '@/lib/http';

// A request nobody awaits (a suspended account's permissions) must not surface
// as an unhandled rejection; whoever does await it still sees the error.
const quiet = (promise) => {
  promise.catch(() => {});
  return promise;
};

/**
 * The requests app boot waits on besides `/me`, started at the same moment.
 * They used to start only after `/me` answered.
 *
 * `/settings` already went out for every account before the suspended check,
 * so it keeps the client's normal handling. Permissions and preferences were
 * skipped for a suspended account, and the API answers them with
 * `err_suspended` — which would log the user out instead of showing the
 * suspended screen — so they opt out of that logout; `bootstrap` discards them
 * unread in that case.
 */
export const startBootRequests = () => ({
  settings: quiet(http.get('/settings')),
  permission: quiet(http.get('/me/permission', { skipAuthLogout: true })),
  preferences: quiet(http.get('/user_preference', { skipAuthLogout: true })),
});
